<fieldset class="prom-colorpicker">
    <legend class="prom-colorpicker__legend">
        <span class="prom-colorpicker__title">{label}</span>
        {#if description}
            <span class="prom-colorpicker__description">{description}</span>
        {/if}
    </legend>
    <div class="prom-colorpicker__wrapper">
        {#each colours as colour}
        <label class="prom-colorpicker__option">
            <input
                checked={selected === colour.className}
                class="prom-colorpicker__input | screen-reader"
                disabled={disabled}
                name="colorpicker_{name}"
                type="radio"
                value={colour.className}
                on:change = {select}>
            <span class="prom-colorpicker__labelwrapper">
                <span class="prom-colorpicker__label {colour.className}">{colour.className} ({colour.hexCode})</span>
            </span>
        </label>
        {/each}
    </div>
</fieldset>

<script>
    import { createEventDispatcher } from 'svelte';

    const dispatch = createEventDispatcher();

    export let colours = [];
    export let description = '';
    export let disabled = false;
    export let label = '';
    export let name = '';
    export let selected = '';

    function select(event) {
        selected = event.currentTarget.defaultValue;
        dispatch('change', event);
    }
</script>
